var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-select',{staticClass:"tw-font-sans tw-cursor-pointer",attrs:{"id":"language-select","options":_setup.languageList,"size":_vm.size},model:{value:(_setup.language),callback:function ($$v) {_setup.language=$$v},expression:"language"}})
}
var staticRenderFns = []

export { render, staticRenderFns }